import {
  Braces,
  Check,
  Heading1,
  Info,
  MessageSquareText,
  Minus,
  MousePointerClick,
  Paperclip,
  Table2,
  Vote,
} from "lucide-react";
import type { ReactNode } from "react";

type InsertMenuProps = {
  hasHeading: boolean;
  onClose: () => void;
  onAttach: () => void;
  onAddText: () => void;
  onAddActions: () => void;
  onAddVote: () => void;
  onAddDivider: () => void;
  onAddHeading: () => void;
  onAddContext: () => void;
  onAddTable: () => void;
  onAddMarkdown: () => void;
};

function Item({
  icon,
  label,
  onClick,
  disabled,
  selected,
}: {
  icon: ReactNode;
  label: string;
  onClick: () => void;
  disabled?: boolean;
  selected?: boolean;
}) {
  return (
    <button type="button" role="menuitem" disabled={disabled} onClick={onClick}>
      {icon}
      <span>{label}</span>
      {selected && <Check className="insert-menu-check" size={13} />}
    </button>
  );
}

export function InsertMenu({
  hasHeading,
  onClose,
  onAttach,
  onAddText,
  onAddActions,
  onAddVote,
  onAddDivider,
  onAddHeading,
  onAddContext,
  onAddTable,
  onAddMarkdown,
}: InsertMenuProps) {
  const run = (action: () => void) => {
    action();
    onClose();
  };
  return (
    <div className="popover composer-insert" role="menu" aria-label="Add to message">
      <Item icon={<Paperclip size={16} />} label="Upload file" onClick={() => run(onAttach)} />
      <div className="insert-menu-separator" />
      <Item icon={<MessageSquareText size={16} />} label="Text" onClick={() => run(onAddText)} />
      <Item
        icon={<Heading1 size={16} />}
        label="Heading"
        disabled={hasHeading}
        selected={hasHeading}
        onClick={() => run(onAddHeading)}
      />
      <Item icon={<Minus size={16} />} label="Divider" onClick={() => run(onAddDivider)} />
      <Item icon={<Info size={16} />} label="Context" onClick={() => run(onAddContext)} />
      <Item icon={<Table2 size={16} />} label="Table" onClick={() => run(onAddTable)} />
      <div className="insert-menu-separator" />
      <Item icon={<MousePointerClick size={16} />} label="Buttons" onClick={() => run(onAddActions)} />
      <Item icon={<Vote size={16} />} label="Vote" onClick={() => run(onAddVote)} />
      <div className="insert-menu-separator" />
      <Item icon={<Braces size={16} />} label="Markdown" onClick={() => run(onAddMarkdown)} />
    </div>
  );
}
